import React from "react"
import { Link } from "gatsby"

const Autolink = ({ to, blank = true, children }) => {
  const external = to != null && to?.trim() !== "" && to?.substr(0, 1) !== "/"

  if (to === null || to.trim() === "") {
    return <>{children}</>
  } else if (external) {
    return (
      <a
        href={to}
        rel={blank ? "noopener noreferrer" : null}
        target={blank ? "_blank" : null}
      >
        {children}
      </a>
    )
  } else {
    return <Link to={to}>{children}</Link>
  }
}

export default Autolink
